//export const baseUrl = 'http://derakhshan.pythonanywhere.com';
//export const baseUrl = 'http://94.101.185.252';
export const baseUrl = 'https://api.ketabbazan.ml';
//export const baseUrl = 'https://ahder.pythonanywhere.com';
//export const baseUrl = 'ahder.pythonanywhere.com';
//export const baseUrl = 'http://98522148.pythonanywhere.com';
//export const baseUrl = 'http://127.0.0.1:8000/';
